interface ApiConfig {
    baseUrl: string;
    timeout: number;
    headers: Record<string, string>;
}

const getApiConfig = (): ApiConfig => {
    // Use REACT_APP_ENVIRONMENT if set, otherwise fall back to NODE_ENV
    const environment = process.env.REACT_APP_ENVIRONMENT || process.env.NODE_ENV as string;

    if (!process.env.REACT_APP_API_BASE_URL) {
        throw new Error(`REACT_APP_API_BASE_URL environment variable is required for ${environment} environment`);
    }

    const configs: Record<string, ApiConfig> = {
        demo: {
            baseUrl: process.env.REACT_APP_API_BASE_URL,
            timeout: 12000,
            headers: {
                'Content-Type': 'application/json',
            },
        },
        staging: {
            baseUrl: process.env.REACT_APP_API_BASE_URL,
            timeout: 12000,
            headers: {
                'Content-Type': 'application/json',
            },
        },
        production: {
            baseUrl: process.env.REACT_APP_API_BASE_URL,
            timeout: 15000,
            headers: {
                'Content-Type': 'application/json',
            },
        },
    };

    const config = configs[environment];
    if (!config) {
        throw new Error(`Unknown environment: ${environment}. Supported environments: ${Object.keys(configs).join(', ')}`);
    }

    return config;
};

export const apiConfig = getApiConfig();

export const getApiUrl = (endpoint: string): string => {
    const cleanEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
    return `${apiConfig.baseUrl}${cleanEndpoint}`;
}; 